import { gql } from '@apollo/client';
import UPDATE_CLASSROOM_SETTING_FRAGMENT from '../../fragments/update-classroom-setting-fragment';

const UPDATE_GSS_CLASSROOM_LANGUAGE_SETTING = gql`
  mutation updateGssClassroomSettingLanguage($data: [UpdateGssClassroomSettingLocaleInput!]!) {
    updateGssClassroomSettingLanguage(data: $data) {
      ...UpdateClassroomSettingFragment
    }
  }
  ${UPDATE_CLASSROOM_SETTING_FRAGMENT}
`;

export default UPDATE_GSS_CLASSROOM_LANGUAGE_SETTING;
